export default "__VITE_ASSET__yTk5Ohmm__"